module.exports = __webpack_public_path__ + "static/RoslindaleVariableDeck-VF-9d8f843f0a88fa9c8e38d971d331a857.woff";